<template>
  <div class="block-shipping-status" v-if="shipping">
    <div class="spinner" v-bind:class="{ loading: (shipping.status === 'WAITING' || shipping.status === 'DRAFT' || shipping.status === 'READY') }" v-if="!mini">
      <div class="loader">
        <div class="loader">
          <div class="loader">
            <div class="loader">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="spinner clock" v-bind:class="{ loading: (shipping.status === 'WAITING' || shipping.status === 'DRAFT' || shipping.status === 'READY') && isScheduled }" v-if="!mini"><font-awesome-icon :icon="['far', 'clock']" size="1x" /></div>
    <div md="12" v-show="shipping.status === 'DRAFT' && !isScheduled" class="status" v-translate translate-context="statuses">
      Received by the system
    </div>
    <div md="12" v-show="shipping.status === 'DRAFT' && isScheduled" class="status" translate-context="statuses" v-translate="{scheduledDate: shipping.scheduled_date ? moment(shipping.scheduled_date).local().format('L LT') : ''}">
      Shipping created and scheduled for %{scheduledDate}
    </div>
    <div md="12" v-show="shipping.status === 'WAITING' && !isScheduled" class="status" v-translate>
      Searching for Moover
    </div>
    <div md="12" v-show="shipping.status === 'READY' && !isScheduled" class="status" v-translate translate-context="statuses">
      Ready to be scheduled
    </div>
    <div md="12" v-show="(shipping.status === 'WAITING' || shipping.status === 'READY') && isScheduled" class="status" v-translate="{scheduledDate: shipping.scheduled_date ? moment(shipping.scheduled_date).local().format('L LT') : ''}">
      Scheduled for %{scheduledDate}
    </div>
    <div md="12" v-show="shipping.status === 'CONFIRMED'" class="status" v-translate>
      Moover in transit to origin
    </div>
    <div md="12" v-show="shipping.status === 'INTRANSIT'" class="status" v-translate>
      Moover in transit to destination
    </div>
    <div md="12" v-show="shipping.status === 'DELIVERED'" class="status" v-translate>
      Shipping delivered! :)
    </div>
    <div md="12" v-show="shipping.status === 'CANCELED'" class="status" v-translate>
      Shipping canceled! :(
    </div>
    <div md="12" v-show="shipping.status === 'INCIDENCE'" class="status text-warning" v-translate>
      Shipping on incidence!
    </div>
    <div md="12" v-show="shipping.status === 'TOBERETURNED'" class="status text-warning" v-translate translate-context="statuses">
      To be returned to sender
    </div>
    <div md="12" v-show="shipping.status === 'RETURNED'" class="status text-danger" v-translate>
      Returned to sender!
    </div>
    <div v-if="(shipping.status === 'TOBERETURNED' || shipping.status === 'INCIDENCE') && shipping.status_history.length > 0 && shipping.status_history[0].details" class="text-left my-2">
      <p class="text-dark"><span class="bg-warning">&nbsp;{{statusReasonsStrings[shipping.status_history[0].details.reason] || shipping.status_history[0].details.reason}}&nbsp;</span></p>
      <p v-if="visits > 0" class="text-dark"><translate>Visits</translate>: <span class="bg-warning">&nbsp;{{visits}}&nbsp;</span></p>
    </div>
    <div v-if="shipping.status === 'RETURNED' && shipping.status_history.length > 0 && shipping.status_history[0].details" class="text-left my-2">
      <p class="text-dark"><translate>Reason</translate>: <span class="bg-danger text-light">&nbsp;{{shipping.status_history[0].details.reason}}&nbsp;</span></p>
    </div>
  </div>
</template>

<script>
import constants from '@/common/constants'

export default {
  name: 'ShippingStatuses',
  data() {
    return {
      visits: 0
    }
  },
  props: {
    shipping: {
      type: Object,
      required: true,
      default: () => {}
    },
    mini: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isScheduled() {
      return this.shipping.scheduled_date && this.moment.utc(this.shipping.scheduled_date) > this.moment().utc()
    }
  },
  mixins: [constants],
  mounted() {
    if (this.shipping.status === 'INCIDENCE') {
      for (let i = 0; i < this.shipping.status_history.length; i++) {
        if (this.shipping.status_history[i].details && (this.shipping.status_history[i].details.reason === 'absent_recipient' || this.shipping.status_history[i].details.reason === 'absent_client')) {
          this.visits++
        }
      }
    }
  }
}
</script>

<style lang="scss">
.text-muted {
  .shipping-status {
    background: none !important
  }
}
</style>
